/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const RefreshStrokeIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M19.7781 9.6715L17.3032 7.19663C14.3744 4.26779 9.62546 4.26779 6.69663 7.19663C3.76779 10.1255 3.76779 14.8744 6.69663 17.8032C9.62546 20.7321 14.3744 20.7321 17.3032 17.8032M19.7781 9.6715V5.42886M19.7781 9.6715H15.5355"
          strokeLinecap="round"
        />
      </svg>
    </Icon>
  );
});

export { RefreshStrokeIcon };
